import initialState from './initialState';
import {
  FETCH_TASKS_MANAGER_TAB_TASKS_INIT,
  FETCH_TASKS_MANAGER_TAB_TASKS_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_TASKS_FAILURE,
  FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_INIT,
  FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_FAILURE,
  FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_INIT,
  FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_FAILURE,
  FETCH_TASKS_MANAGER_TAB_TASKS_TASK_INIT,
  FETCH_TASKS_MANAGER_TAB_TASKS_TASK_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_TASKS_TASK_FAILURE,  
  FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_INIT,
  FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_FAILURE, 
  FETCH_TASKS_MANAGER_TAB_TASKS_CHANGE_FORM_VALUE,
  FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_INIT,
  FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_FAILURE,
  FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_INIT,
  FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_FAILURE,
  RESET_TASKS_MANAGER_TAB_TASKS_TASK,
  SET_FILTER_TASKS_MANAGER_TAB_TASKS,
  RESET_TASKS_MANAGER_TAB_TASKS,
  FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_INIT,
  FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_SUCCESS,
  FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_FAILURE
} from '../../actions/tasks_manager_tab_tasks/types';
import ObjGeneral from '../../containers/function';

export default function tasksManagerTabTasks(state = initialState, action) {
  switch (action.type) {
    case FETCH_TASKS_MANAGER_TAB_TASKS_INIT:
      return {
        ...state,
        loading: true
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_SUCCESS:
      return {
        ...state,
        datos: action.payload.data,
        loading: false,
        status: action.payload.status
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_FAILURE:
      return {
        ...state,
        datos: [],
        loading: false
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_INIT:
      return {
        ...state,
        loadingTableSpiner: true
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_SUCCESS:
      return {
        ...state,
        datos: action.concat
          ? { 
            tasks: state.datos.tasks.concat(action.payload.data.tasks), 
            stats: state.datos.stats 
          }
          : action.payload.data,
        loadingTableSpiner: false,
        status: action.payload.status
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_NO_LOADING_FAILURE:
      return {
        ...state,
        datos: [],
        loadingTableSpiner: false
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_INIT:
      return {
        ...state
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.data,
        statusCount: action.payload.status
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_COUNT_FAILURE:
      return {
        ...state,
        count: {}
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_TASK_INIT:
      return {
        ...state,
        activeTask: {
          ...state.activeTask,
          id: action.payload.id,
          datos: null,
          status: null,
          loading: true
        },
        saveTask: {
          ...state.saveTask,
          id: action.payload.id,
          status: null
        }
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_TASK_SUCCESS:
      var datosSave = null;
      if(action.payload.status == 200 && action.payload.data && action.payload.data.fields) {
        datosSave = {};
        for(var i=0;i<action.payload.data.fields.length; i++) {
          var field = action.payload.data.fields[i];
          datosSave[field.key] = {
            ...(datosSave[field.key] ? datosSave[field.key] : {}),
            key: field.key,
            value: field.value,
            type: field.type,
            isEditable: field.metadata.isEditable,
            endpoint: field.metadata.endpoint,
            options: field.metadata.options,
            status: null,
            loading: false
          }

          if(field.metadata.endpoint && field.metadata.endpoint.match(/\{(.*?)\}/g)) {
            var parentDependants = field.metadata.endpoint.match(/\{(.*?)\}/g);
            for(var j=0; j<parentDependants.length; j++) {
              var parentKey = parentDependants[j].replace("{","").replace("}","");
              datosSave[parentKey] = {
                ...(datosSave[parentKey] ? datosSave[parentKey] : {}),
                dependants: datosSave[parentKey] && datosSave[parentKey].dependants ?
                  datosSave[parentKey].dependants.concat([field.key]) : [field.key]
              }
            }
          }
        }
      }
      return {
      ...state,
        activeTask: {
          ...state.activeTask,
          datos: action.payload.data,
          loading: false,
          status: action.payload.status
        },
        saveTask: {
          ...state.saveTask,
          datos: datosSave
        }    
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_TASK_FAILURE:
      return {
        ...state,
        activeTask: {
          ...state.activeTask,
          datos: null,
          loading: false
        }
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_INIT:
      var fieldDatosSave = ObjGeneral.cloneObject(state.saveTask.datos[action.fieldKey]);
      var datosAux = {};
      fieldDatosSave.loading = true;
      datosAux[action.fieldKey] = fieldDatosSave;
      return {
        ...state,
        saveTask: {
          ...state.saveTask,
          datos: {
            ...state.saveTask.datos,
            ...datosAux
          },
        }
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_SUCCESS:
      var fieldDatosSave = ObjGeneral.cloneObject(state.saveTask.datos[action.fieldKey]);
      var datosAux = {};
      fieldDatosSave.loading = false;
      fieldDatosSave.status = action.payload.status;
      fieldDatosSave.options = action.payload.data;
      datosAux[action.fieldKey] = fieldDatosSave;
      return {
        ...state,
        saveTask: {
          ...state.saveTask,
          datos: {
            ...state.saveTask.datos,
            ...datosAux
          },
        }
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_GET_TASK_FIELD_ENDPOINT_FAILURE:
      var fieldDatosSave = ObjGeneral.cloneObject(state.saveTask.datos[action.fieldKey]);
      var datosAux = {};
      fieldDatosSave.loading = false;
      fieldDatosSave.status = 500;
      fieldDatosSave.options = null;
      datosAux[action.fieldKey] = fieldDatosSave;
      return {
        ...state,
        saveTask: {
          ...state.saveTask,
          datos: {
            ...state.saveTask.datos,
            ...datosAux
          },
        }
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_CHANGE_FORM_VALUE:
      var datosSave = ObjGeneral.cloneObject(state.saveTask.datos);
      if(datosSave[action.fieldKey]) {
        datosSave[action.fieldKey].value = action.fieldValue;
      }
      return {
      ...state,
        saveTask: {
          ...state.saveTask,
          datos: datosSave
        }    
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_INIT:
      return {
        ...state,
        saveTask: {
          ...state.saveTask,
          action: action.action,
          status: null,
          loading: true,
          message: null
        }        
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_SUCCESS:
      return {
      ...state,
        saveTask: {
          ...state.saveTask,
          loading: false,
          status: action.payload.status,
          message: action.payload.data 
        }    
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_SAVE_TASK_FAILURE:
      return {
        ...state,
        saveTask: {
          ...state.saveTask,
          loading: false,
          status: 500,
          message: null
        }
      };
    case RESET_TASKS_MANAGER_TAB_TASKS_TASK:
      return {
        ...state,
        activeTask: {
          ...initialState.activeTask
        }
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_INIT:
      return {
        ...state,
        annulTasks: {
          ...state.annulTasks,
          status: null,
          loading: true
        }        
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_SUCCESS:
      return {
      ...state,
        annulTasks: {
          ...state.annulTasks,
          loading: false,
          status: action.payload.status
        }    
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_ANNUL_FAILURE:
      return {
        ...state,
        annulTasks: {
          ...state.annulTasks,
          loading: false
        }
      };
    case RESET_TASKS_MANAGER_TAB_TASKS:
      return {
        ...initialState,
        downloading: state.downloading,
        filters: state.filters
      };
    case SET_FILTER_TASKS_MANAGER_TAB_TASKS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_INIT:
      return {
        ...state,
        downloading: true
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_SUCCESS:
      return {
        ...state,
        downloading: false
      };
    case FETCH_TASKS_MANAGER_TAB_TASKS_DOWNLOADING_FAILURE:
      return {
        ...state,
        downloading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/tasks_manager_tab_tasks/index.js